import { Heart, Flame, Briefcase, Package, Building2, type LucideIcon } from "lucide-react";
import type { PlanService } from "@/lib/plan-wizard-schema";

interface Tile {
  service: PlanService;
  label: string;
  description: string;
  icon: LucideIcon;
}

const TILES: Tile[] = [
  {
    service: "wedding",
    label: "Wedding",
    description: "Curated menu and custom quote for your special day.",
    icon: Heart,
  },
  {
    service: "live_service",
    label: "Live Service",
    description: "Chef-attended stations — pasta bar, carvery, and more.",
    icon: Flame,
  },
  {
    service: "corporate",
    label: "Corporate",
    description: "Drop-off, buffet, or plated service for your business event.",
    icon: Briefcase,
  },
  {
    service: "drop_off",
    label: "Drop-off / Pickup",
    description: "Delivery or pickup trays. Tell us what you need and we'll send our take-out menu.",
    icon: Package,
  },
  {
    service: "venue",
    label: "Book the Venue",
    description: "Check availability for private events at our space.",
    icon: Building2,
  },
];

interface Props {
  onSelect: (service: PlanService) => void;
}

export function ServiceSelector({ onSelect }: Props) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {TILES.map((tile) => {
        const Icon = tile.icon;
        return (
          <button
            key={tile.service}
            type="button"
            onClick={() => onSelect(tile.service)}
            className="group relative flex flex-col items-start gap-3 rounded-xl border border-border/60 bg-card p-6 text-left transition-all hover:border-primary/60 hover:bg-muted/30 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 min-h-[44px]"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <Icon className="h-6 w-6" />
            </div>
            <div className="min-w-0">
              <h3 className="font-serif text-xl font-semibold text-foreground">
                {tile.label}
              </h3>
              <p className="mt-1 text-sm text-muted-foreground leading-relaxed">
                {tile.description}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
